module.exports = __webpack_public_path__ + "static/lc-logo-ru-5f8317e25f367f917947506652fe66b8.png";